import { createApi } from '@reduxjs/toolkit/query/react';
import { REPORTS_DATA_API } from 'services/constants';
import { rawBaseQuery } from 'services/shared';
import {
  ReportsReportDataResponse,
  ReportSummaryDataResponse,
} from 'services/types';

type ReportSummaryDataParams = {
  selectedContext: string;
  selectedReport: string;
};

type ReportsReportDataParams = {
  selectedContext: string;
  selectedReport: string;
  selectedFund: string;
};

export const reportsDataApi = createApi({
  reducerPath: REPORTS_DATA_API,
  baseQuery: rawBaseQuery,
  endpoints: (builder) => ({
    getReportSummaryData: builder.query<
      ReportSummaryDataResponse[],
      ReportSummaryDataParams
    >({
      query: ({ selectedContext, selectedReport }) =>
        encodeURI(
          `/contexts/${selectedContext}/funds/summary?reportName=${selectedReport}`
        ),
    }),
    getReportsReportData: builder.query<
      ReportsReportDataResponse[],
      ReportsReportDataParams
    >({
      query: ({ selectedContext, selectedReport, selectedFund }) =>
        encodeURI(
          `/contexts/${selectedContext}/funds/${selectedFund}/results?reportName=${selectedReport}`
        ),
    }),
  }),
});

export const { useGetReportSummaryDataQuery, useGetReportsReportDataQuery } =
  reportsDataApi;
